import { DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import Box from '@liquidweb-dev/undercurrent/Box';
import LockIcon from '@liquidweb-dev/undercurrent/icons/lucide/Lock';
import DialogUTM from 'components/standard/DialogUTM';
import SecuritySetupImg from 'images/utm/security-setup.png';

interface SecuritySetupProps extends Omit<DialogProps, 'onClose'> {
	onClose: () => void;
}

const SecuritySetup = ({ onClose, ...dialogProps }: SecuritySetupProps) => {
	return (
		<DialogUTM
			{...dialogProps}
			image={SecuritySetupImg}
			badge={{
				icon: LockIcon,
				label: 'Security Setup',
			}}
			dialogContent={{
				title: 'Your server is live — secure it now',
				description: (
					<Box
						sx={{
							display: 'grid',
							gap: 400,
						}}
					>
						<Typography variant="body-md">
							{' '}
							Go to the{' '}
							<Typography variant="body-md" fontWeight={700}>
								Networking tab
							</Typography>{' '}
							of your server to set up your firewall and block unwanted traffic.
						</Typography>
						<Typography variant="body-md">
							{' '}
							For continuous protection, visit your server&apos;s{' '}
							<Typography variant="body-md" fontWeight={700}>
								Settings tab
							</Typography>{' '}
							to enable ThreatDown or Imunify360 for real-time threat detection
							and malware defense.
						</Typography>
					</Box>
				),
			}}
			onClose={onClose}
		/>
	);
};

export default SecuritySetup;
